import React from 'react';
export function WmLogo({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 120 70" role="img" aria-label="Weedmaps" className={className} fill="none" data-id="element-517">
      {/* wm wordmark */}
      <text x="60" y="40" textAnchor="middle" fontFamily="'Manrope', 'Inter', system-ui, sans-serif" fontSize="44" fontWeight="800" letterSpacing="-2" fill="#00CDBE" data-id="element-518">
        wm
      </text>
      {/* signature smile */}
      <path d="M30 50 Q60 70 90 50" stroke="#00CDBE" strokeWidth="5" strokeLinecap="round" data-id="element-519" />
    </svg>;
}